// EditorSidePanel contains all toolbar buttons for map interaction.

import { useCopyTileContext } from 'app/src/editor/CopyTileContext';
import EditInstructionsPanel from 'app/src/editor/EditInstructionsPanel';
import { usePluginsContext } from 'app/src/editor/PluginsContext';
import ToolbarButton, { ToolbarButtonType } from 'app/src/editor/ToolbarButton';
import * as React from 'react';

export default function EditorSidePanel(): React.ReactElement {
	const { copiedTiles } = useCopyTileContext();

	const plugins = usePluginsContext();
	const canonicalTilesPerPlugin = Array.from(plugins).map((plugin) => plugin.getCanonicalTiles());
	const canonicalTiles = canonicalTilesPerPlugin.reduce((a, b) => [...a, ...b]);

	return (
		<div className="EditorSidePanel">
			<div className="EditorSidePanel-header">
				<ToolbarButton type={ToolbarButtonType.Wall} />
				<ToolbarButton type={ToolbarButtonType.Star} />
				<ToolbarButton type={ToolbarButtonType.Robot} />
				<ToolbarButton type={ToolbarButtonType.Rotate} />
				<ToolbarButton type={ToolbarButtonType.Copy} />
			</div>
			<div className="EditorSidePanel-copiedTiles">
				{copiedTiles.map((tile, index) => {
					return (
						<ToolbarButton
							key={`EditorSidePanel-copied-tile--${index}`}
							type={ToolbarButtonType.AddTile}
							tile={tile}
						/>
					);
				})}
			</div>
			<div className="EditorSidePanel-fixedTiles">
				{canonicalTiles.map((tile, index) => {
					return (
						<ToolbarButton
							key={`EditorSidePanel-fixed-tile--${index}`}
							type={ToolbarButtonType.AddTile}
							tile={tile}
						/>
					);
				})}
			</div>
			<div className="EditorSidePanel-instructions">
				<EditInstructionsPanel />
			</div>
		</div>
	);
}
